import React, { Component } from 'react';
import firebase from 'firebase/app'; // ← v8 호환
import 'firebase/auth';
import 'firebase/firestore';
import { FormControl, FormGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { setUserProfile, updateUserFavourites } from "../../actions/userProfileActions";
import './login.css';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: ""
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        event.preventDefault();

        firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
            .then(authData => {
                console.log('signInWithEmailAndPassword is called : ', authData);
                // 로그인 성공 시 추가 로직 가능 (예: Redux에 유저 정보 저장)
                const user = authData.user;
                if (user) {
                    this.props.setUserProfile(user.uid, user.email);
                }
            })
            .catch(error => {
                console.log('signInWithEmailAndPassword error : ', error.code, error.message);
            });
    };

    render() {
        let loginView = null;

        if (!this.props.userProfile.email) {
            loginView = (
                <div>
                    <form onSubmit={this.handleSubmit}>
                        <FormGroup controlId="email">
                            <FormControl
                                type="text"
                                value={this.state.email}
                                placeholder="email"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup controlId="password">
                            <FormControl
                                type="password"
                                value={this.state.password}
                                placeholder="password"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <div className="submit-buttons">
                            <button type="submit" className="btn btn-success">Login</button>
                        </div>
                    </form>
                    <div className="info">
                        <div className="text-center">
                            Don't have an account? <Link to='/signup'>Sign up</Link>
                        </div>
                    </div>
                </div>
            );
        } else {
            loginView = (
                <div>
                    <div className="info">
                        <div className="text-center">
                            You already logged in. <Link to='/ctcae'>Home</Link>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="login-container">
                <div className="row">
                    <div className="col-sm-4 col-sm-offset-4">
                        {loginView}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userProfile: state.userProfile
});

export default connect(mapStateToProps, { setUserProfile, updateUserFavourites })(Login);


// WEBPACK FOOTER //
// ./src/component/login/login.js